import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Check2 = function Check2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M12.288 23.872a2.318 2.318 0 0 0 3.264 0L26.944 12.48a2.318 2.318 0 0 0 0-3.264 2.318 2.318 0 0 0-3.264 0L12.288 20.608a2.318 2.318 0 0 0 0 3.264z"
    }), /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M6.528 14.912a2.318 2.318 0 0 0 0 3.264l5.696 5.696a2.318 2.318 0 0 0 3.264 0 2.318 2.318 0 0 0 0-3.264l-5.696-5.696a2.318 2.318 0 0 0-3.264 0z"
    })]
  });
};
export default Check2;